import {Route, Routes} from 'react-router-dom'
import {Registration} from './auth/components/Registration'
import {ForgotPassword} from './auth/components/ForgotPassword'
import {Login} from './auth/components/Login'
import {AuthLayout} from '../layouts/AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout promoContentVisible={false} />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
